import {configureStore} from "@reduxjs/toolkit";
import adminUserReducer from "./UserSlice";

export const store = configureStore({
    //필요한 reducer 추가
    reducer: {
        user: adminUserReducer, //관리자권한 Reducer
    },
});
